import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { statusSchedule } from 'app/core/data/calendar.json';
import { scheduleI, scheduleStatus } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { LayoutService } from 'app/core/http/services/layout.service';
import { AuthService } from 'app/core/http/services/auth.service';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { Encounter } from 'app/core/interfaces/encounter';

@Component({
  selector: 'page-schedule-edit-status',
  templateUrl: './schedule-edit-status.component.html',
  styleUrls: ['./schedule-edit-status.component.scss'],
})
export class ScheduleEditStatusComponent implements OnInit {
  public status = '';
  public scheduleStatus: any[] = [
    {
      id: 'planned',
      text: 'Pendente',
      color: 'red',
      icon: 'error',
    },
    {
      id: 'finished',
      text: 'Confirmado',
      color: 'grey',
      icon: 'check_circle',
    },
    {
      id: 'in-progress',
      text: 'Em atendimento',
      color: 'orange',
      icon: 'pending',
    },
  ];
  public schedule: scheduleI = <scheduleI>{};

  public encounter!: Encounter;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    public layout: LayoutService,
    private auth: AuthService,
    private encounterService: EncounterService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  ngOnInit(): void {
    if (this.data.param.encounter) {
      this.schedule = this.data.param.schedule;

      this.encounter = this.data.param.encounter;

      this.status = this.encounter.status || '';
    }
  }

  saveStatus() {
    this.encounter.status = this.status;

    this.encounterService.updateNew(this.encounter.encounter_id!, this.encounter).subscribe({
      next: (encounter: Encounter) => {
        this.dialogRef.close(encounter);
      },
      error: (err) => {
        console.log('error', err);
      },
    });
  }
}
